import React from "react";
import { faEdit, faTrash } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Link } from "react-router-dom";
import { FaEye } from "react-icons/fa";

export const tableConstants = (handleDelete, permissions, handleDownload) => {
  let count = 1;
  let formatedData = [
    {
      title: "S.No",
      render: () => {
        return <span>{count++}</span>;
      },
    },
    {
      title: "title",
      render: (rowData) => {
        return <span>{rowData.homework_title}</span>;
      },
    },
    {
      title: "type",
      render: (rowData) => {
        return <span>{rowData.homework_type}</span>;
      },
    },
    {
      title: "class",
      render: (rowData) => {
        return <span>{rowData.program.name}</span>;
      },
    },
    {
      title: "subject",
      render: (rowData) => {
        return <span>{rowData.subject.name}</span>;
      },
    },
    {
      title: "Start Date",
      render: (rowData) => {
        return <span>{rowData.start_date ? rowData.start_date : "N/A"}</span>;
      },
    },
    {
      title: "End Date",
      render: (rowData) => {
        return <span>{rowData.end_date ? rowData.end_date : "N/A"}</span>;
      },
    },
    {
      title: "Assigned Date",
      render: (rowData) => {
        return (
          <span>{rowData.assigned_date ? rowData.assigned_date : "N/A"}</span>
        );
      },
    },
    {
      title: "Attachment",
      render: (rowData) => {
        return (
          <span>
            {rowData.homework_attachment && (
              <FaEye
                style={{ cursor: "pointer", color: "var(--color-link)" }}
                onClick={() => {
                  handleDownload(rowData.homework_attachment);
                }}
              />
            )}
          </span>
        );
      },
    },
  ];

  if (
    permissions.includes("homework.update") ||
    permissions.includes("homework.delete")
  ) {
    formatedData.push({
      title: "Action",
      render: (rowData) => {
        return (
          <React.Fragment>
            {permissions.includes("homework.update") && (
              <Link to={`/homework/update/${rowData.id}`} className="mr-2">
                <FontAwesomeIcon icon={faEdit} color="blue" />
              </Link>
            )}
            &nbsp;&nbsp;
            {permissions.includes("homework.delete") && (
              <span
                style={{ cursor: "pointer" }}
                onClick={() => {
                  if (
                    window.confirm("Are you sure you wish to delete this item?")
                  )
                    handleDelete(rowData.id);
                }}
              >
                <FontAwesomeIcon icon={faTrash} color="red" />
              </span>
            )}
          </React.Fragment>
        );
      },
    });
  }
  return formatedData;
};
